import { SVGProps } from "react";
import { Icon } from "./icon";

export const CaretDown = ({
  width = 24,
  height = 24,
  ...props
}: {
  width?: number;
  height?: number;
} & SVGProps<SVGSVGElement>) => {
  return (
    <Icon
      svg="caret-down"
      width={width}
      height={height}
      {...{ ...props, onClick: undefined }}
    />
  );
};
